import { Component, computed } from '@angular/core';
import { CustomWidget } from '../widget';
import { AbbGaugeComponent } from '@components/abb-gauge/abb-gauge.component';
import { TPipe, TRANSLATION_PREFIX } from '@pipes/t.pipe';

@Component({
  selector: 'abb-gauge-widget',
  standalone: true,
  imports: [AbbGaugeComponent, TPipe],
  template: `
    @if (value() === -1) {
      <div
        class="flex items-center justify-center h-full text-center text-abb-font/70"
      >
        {{ "You don't have permission to view this property or group" | t }}
      </div>
    } @else {
      <abb-gauge
        [min]="min()"
        [max]="max()"
        [value]="value()"
        [highAlarm]="targetMax() ?? undefined"
        [lowAlarm]="targetMin() ?? undefined"
        [metric]="metric()"
        [thresholdType]="'line'"
        class="w-[60%] block mx-auto"
      ></abb-gauge>
    }
  `,
  styles: ``,
  host: {
    class: 'h-full w-full block',
  },
  providers: [
    {
      provide: TRANSLATION_PREFIX,
      useValue: 'dashboards',
    },
  ],
})
export class GaugeWidgetComponent extends CustomWidget {
  min = computed(() => this.widget().min ?? 0);
  max = computed(() => this.widget().max ?? 100);

  value = computed(() => {
    const data = this.data();
    if (data && data.__typename === 'GaugeData') {
      return data.value;
    }
    return 0;
  });

  metric = computed(() => {
    const data = this.data();
    if (data && data.__typename === 'GaugeData') {
      return data.metric;
    }
    return 0;
  });


  targetMin = computed(() => this.widget().targetMin)
  targetMax = computed(() => this.widget().targetMax)
}
